import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../extras/Button";
import { getPendingRequest, getUpdatePendingRequest, pendingProductStatus, pendingProductUpdateStatus, pendingRejectProductStatus } from "../../../redux/slice/productSlice";
import Table from "../../extras/Table";
import Skeleton from "react-loading-skeleton";
import dayjs from "dayjs";
import Pagination from "../../extras/Pagination";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AcceptProductWarning, AcceptWarning, permissionError, RejectProductWarning, RejectWarning, warning } from "../../../util/Alert";
import { IconCircleDashedCheck, IconCircleDashedX, IconInfoCircle } from "@tabler/icons-react";
import MultiButton from "../../extras/MultiButton";

const PendingProduct = () => {
    const dispatch = useDispatch();
    const [type, setType] = useState("Pending");
    const [status, setStatus] = useState("New Items");
    const [data, setData] = useState([]);
    const { pendingReq, total, pendingUpdateReq } = useSelector((state) => state.product)
    const { setting } = useSelector((state) => state.setting)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [updateData, setupdateData] = useState([]);
    const [modal, setModal] = useState(false);
    const navigate = useNavigate()
    const hasPermission = useSelector((state) => state.auth.admin.flag);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event, 10));
        setPage(0);
    };


    useEffect(() => {
        if (status === "New Items") {
            dispatch(getPendingRequest(type));
            setData([]);
        } else {
            dispatch(getUpdatePendingRequest(type));
            setData([]);
        }
    }, [status, type, page, rowsPerPage])
    useEffect(() => {
        if (status === "New Items") {
            setData(pendingReq);
        } else {
            setupdateData(pendingUpdateReq);
        }
    }, [pendingReq]);
    const handleAccept = async (id) => {
        if (status === "New Items") {
            try {
                const data = await AcceptProductWarning("Accept");
                const yes = data?.isConfirmed;
                console.log("yes", yes);
                if (yes) {
                    if (!hasPermission) return permissionError();

                    dispatch(pendingProductStatus({ productId: id, type: "Approved" }))
                        .then((res) => {
                            console.log("ressssssss", res)
                            if (res?.payload?.status) {
                                toast.success(res?.payload?.message)
                                dispatch(getPendingRequest(type))
                            } else {
                                toast.error(res?.payload?.message)
                            }
                        })
                }
            } catch (err) {
                console.log(err);
            }
        } else {
            try {
                const data = await AcceptProductWarning("Accept");
                const yes = data?.isConfirmed;
                console.log("yes", yes);
                if (yes) {
                    if (!hasPermission) return permissionError();
                    dispatch(pendingProductUpdateStatus({ productId: id, type: "Approved" }))
                        .then((res) => {
                            console.log("ressssssss", res)
                            if (res?.payload?.status) {
                                toast.success(res?.payload?.message)
                                dispatch(getPendingRequest(type))
                            } else {
                                toast.error(res?.payload?.message)
                            }
                        })
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    const handleReject = async (id) => {
        if (status === "Create") {
            try {
                const data = await RejectProductWarning("Reject");
                const yes = data?.isConfirmed;
                console.log("yes", yes);
                if (yes) {
                    if (!hasPermission) return permissionError();
                    dispatch(pendingProductStatus({ productId: id, type: "Rejected" }))
                        .then((res) => {
                            console.log("ressssssss", res)
                            if (res?.payload?.status) {
                                toast.success(res?.payload?.message)
                                dispatch(getPendingRequest(type))
                            } else {
                                toast.error(res?.payload?.message)
                            }
                        })
                }
            } catch (err) {
                console.log(err);
            }
        } else {
            try {
                const data = await RejectProductWarning("Reject");
                const yes = data?.isConfirmed;
                console.log("yes", yes);
                if (yes) {
                    if (!hasPermission) return permissionError();
                    dispatch(pendingRejectProductStatus({ productId: id, type: "Rejected" }))
                        .then((res) => {
                            console.log("ressssssss", res)
                            if (res?.payload?.status) {
                                toast.success(res?.payload?.message)
                                dispatch(getPendingRequest(type))
                            } else {
                                toast.error(res?.payload?.message)
                            }
                        })
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    // const handleReject = (id) => {
    //     if (status === "Create") {
    //         dispatch(pendingProductStatus({ productId: id, type: "Rejected" }))
    //             .then((res) => {
    //                 console.log("ressssssss", res)
    //                 if (res?.payload?.status) {
    //                     toast.success(res?.payload?.message)
    //                     dispatch(getPendingRequest(type))
    //                 } else {
    //                     toast.error(res?.payload?.message)
    //                 }
    //             })
    //     } else {
    //         dispatch(pendingRejectProductStatus({ productId: id, type: "Rejected" }))
    //             .then((res) => {
    //                 console.log("ressssssss", res)
    //                 if (res?.payload?.status) {
    //                     toast.success(res?.payload?.message)
    //                     dispatch(getUpdatePendingRequest(type))
    //                 } else {
    //                     toast.error(res?.payload?.message)
    //                 }
    //             })
    //     }
    // }
    const handleInfoSettlement = (id) => {
        navigate("/admin/product/productTableDetails", {
            state: {
                id,
            },
        });
    };
    const mapData = [
        {
            Header: "No",
            width: "20px",
            Cell: ({ index }) => <span>{parseInt(index) + 1}</span>,
        },
        {
            Header: "Product",
            body: "image",
            Cell: ({ row }) => (
                <div className="d-flex ">
                    <div className="userProfile">
                        <img
                            alt=""
                            src={row?.mainImage}

                            style={{ height: "50px", width: "50px", overflow: "hidden" }}
                        />
                    </div>
                    <span className="ms-2 boxCenter">{row.productName}</span>
                </div>
            ),
        },

        { Header: "Product Code", body: "productCode" },

        {
            Header: `Price (${setting?.currencySymbol || "$"})`,
            body: "price",
            Cell: ({ row }) => (
                <span className=" text-dark">${row.price}</span>
            ),
        },
        {
            Header: "Shipping Charges",
            body: "shippingCharges",
            Cell: ({ row }) => <span>${row.shippingCharges}</span>,
        },

        {
            Header: "CreatedDate",
            body: "createdAt",
            Cell: ({ row }) => (
                <span>{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
            ),
        },
        {
            Header: "Create Status",
            body: "status",
            Cell: ({ row }) => (

                <>
                    {status === "New Items" ? (
                        <span className="badge-success " >
                            {row.createStatus}
                        </span>

                    ) : (
                        <span className=" badge-primary" >
                            {row.updateStatus}
                        </span>
                    )}
                </>

            ),
        },
        {
            Header: "Info",
            Cell: ({ row }) => (
                <div className="action-button">
                    <button
                        className="btn btn-sm"
                        onClick={() => handleInfoSettlement(row?._id)}
                    >
                        <IconInfoCircle className="text-secondary" />
                    </button>
                </div>
            ),
        },
        {
            Header: "Accept",
            body: "",
            Cell: ({ row }) =>
            (
                <>
                    <div className="action-button">
                        <button
                            className="btn btn-sm"
                            onClick={() => handleAccept(row?._id)}
                        >
                            <IconCircleDashedCheck className="text-secondary" />
                        </button>
                    </div>

                    {/* <i className="fa-solid fa-check" style={{ color: "green", fontSize: "18px" }} onClick={() => {
                        handleAccept(row?._id)
                        // setModal(true)
                    }}></i> */}
                </>
            ),
        },
        {
            Header: "Reject",
            body: "",
            Cell: ({ row }) => (
                <>
                    {/* <i className="fa-sharp fa-solid fa-xmark" style={{ color: "red", fontSize: "18px" }} onClick={() => {
                        handleReject(row?._id)
                    }}></i> */}
                    <div className="action-button">
                        <button
                            className="btn btn-sm"
                            onClick={() => handleReject(row?._id)}
                        >
                            <IconCircleDashedX className="text-secondary" />
                        </button>
                    </div>
                </>
            ),
        },


        // add more columns as needed
    ];
    return (
        <>
            {
                modal && (
                    <div className="dialog">
                        <div className="w-100">
                            <div className="row justify-content-center">
                                <div className="col-xl-5 col-md-8 col-11">
                                    <div className="mainDiaogBox">

                                        <form>
                                            <p>Would you like to approve the Pending request?</p>

                                            <div className="row formFooter">
                                                <div className="col-12 text-start m0">
                                                    <Button
                                                        className={`bg-gray text-light`}
                                                        text={`Cancel`}
                                                        type={`button`}
                                                        onClick={() => setModal(false)}
                                                    />
                                                    <Button
                                                        type={`submit`}
                                                        className={`text-white m10-left`}
                                                        style={{ backgroundColor: "#1ebc1e" }}
                                                        text={`Update`}
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            <div className="userPage">
                <div className="multi-user-btn mb-3 ">
                    <MultiButton
                        multiButtonSelect={status}
                        setMultiButtonSelect={setStatus}
                        label={["New Items", "Updated Items"]}
                    />
                </div>
                <div className="user-table mb-3">
                <div className="user-table-top">
                        <div className=" d-flex justify-content-between align-items-center w-100 ">
                            <div className="w-100">
                                <h5
                                    className="main-title">
                                    Pending Product
                                </h5>
                            </div>

                        </div>
                    </div>


                    {/* <div className="sellerHeader primeHeader">
                        <div className="row">
                            <div className="col-4 d-flex" id="">

                                <Button
                                    className={`bg-secondary m20-left p-10 mt-5 text-white`}
                                    text={`New Items`}
                                    style={{ padding: "9px 20px" }}
                                    onClick={() => setStatus("Create")}
                                />
                                <Button
                                    className={`bg-primary m20-left p-10 mt-5 text-white`}
                                    text={`Updated Items`}
                                    style={{ padding: "9px 20px" }}
                                    onClick={() => setStatus("Update")}
                                />
                            </div>
                        </div>
                    </div> */}

                    {type == "Pending" && (
                        <>
                            <Table
                                data={status === "Create" ? data : updateData}
                                mapData={mapData}
                                PerPage={rowsPerPage}
                                Page={page}
                                type={"client"}
                            />
                        </>
                    )}
                    <Pagination
                        serverPage={page}
                        type={"server"}
                        onPageChange={handleChangePage}
                        setServerPage={setPage}
                        serverPerPage={rowsPerPage}
                        totalData={total}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                </div>
            </div></>
    )
}
export default PendingProduct;